import React from 'react';

import { checkForAndExecuteDocQueries } from '@util/content';

import { getClient } from '@sanity-lib/client';

import FormatTemplate from '@templates/format';

import {
  allFormatsQueryLight,
  formatBySlugQuery,
} from '@sanity-lib/queries/formats';
import { fetchWithMenu } from '@sanity-lib/util/queries';

export async function getStaticPaths() {
  const client = getClient();
  const formats = await client.fetch(allFormatsQueryLight);

  return {
    paths: formats.map((f) => ({
      params: { slug: f.slug },
    })),
    fallback: 'blocking',
  };
}

export async function getStaticProps({ params, draftMode = false }) {
  const { slug } = params;

  const client = getClient({ preview: draftMode });
  const { format, formats, menu } = await fetchWithMenu(
    client,
    {
      format: formatBySlugQuery,
      formats: allFormatsQueryLight,
    },
    { slug },
  );

  if (!format) {
    return {
      notFound: true,
    };
  }

  const content = await checkForAndExecuteDocQueries(format, client);

  return {
    props: {
      draftMode,
      menu,
      content,
      formats,
    },
  };
}

export default function Page({ menu, content, formats }) {
  return <FormatTemplate content={content} menu={menu} allFormats={formats} />;
}
